import React, { useEffect, useState } from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import NotFound from '../pages/NotFound';

/**
 * ProtectedRoute component that checks if the user has completed OTP verification
 * before allowing access to protected routes.
 * 
 * @param {Object} props 
 * @param {React.ReactNode} props.children 
 * @returns {React.ReactNode} 
 */
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const [isVerified, setIsVerified] = useState(null);

  useEffect(() => {
    const phoneNumber = sessionStorage.getItem('phoneNumber');
    const verificationTimestamp = sessionStorage.getItem('verificationTimestamp');
    if (phoneNumber && verificationTimestamp) {
      const timeSinceVerification = Date.now() - parseInt(verificationTimestamp, 10);
      if (timeSinceVerification < 24 * 60 * 60 * 1000) {
        setIsVerified(true);
        return;
      }
    }
    setIsVerified(false);
  }, []);

  if (isVerified === null) return null; // or a loader
  if (isVerified) return children;
  // If not verified, redirect to OTP verification
  if (location.pathname !== '/otp-verification') {
    return <Navigate to="/otp-verification" replace />;
  }
  // If already on OTP page and not verified, show 404
  return <NotFound />;
};

export default ProtectedRoute;

